import React from 'react';
import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import { Allocations } from 'src/components/enterprise/features/Corporate/components/Form/Allocations/Allocations';
import { AutomatedWelcomeEmails } from 'src/components/enterprise/features/Corporate/components/Form/AutomatedWelcomeEmails/AutomatedWelcomeEmails';
import { ScheduledTeamOrders } from 'src/components/enterprise/features/Corporate/components/Form/ScheduledTeamOrders/ScheduledTeamOrders';
import { OrderingPolicyWrapper } from 'src/components/enterprise/features/Corporate/components/Form/OrderingPolicy/OrderingPolicyWrapper';
import { GrubhubSeamlessPlusWrapper } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/GrubhubSeamlessPlusWrapper';
import { SFTPWrapper } from 'src/components/enterprise/features/Corporate/components/Form/SFTP/SFTPWrapper';
import { PIISensitiveControl } from 'src/components/enterprise/features/Corporate/components/Form/PII/PIISensitiveControl';
import { TaxExemptionControl } from 'src/components/enterprise/features/Corporate/components/Form/TaxExemption/TaxExemptionControl';
import { UniversalLoginControl } from 'src/components/enterprise/features/Corporate/components/Form/UniversalLogin/UniversalLoginControl';
import { SSOWrapper } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/SSOWrapper';
import { OrderCutoffControl } from 'src/components/enterprise/features/Corporate/components/Form/OrderCutoffControl/OrderCutoffControl';
import { OrderRestrictionsProvider } from 'src/common/OrderRestrictions/OrderRestrictionsProvider/OrderRestrictionsProvider';
import { MerchantRestrictionsWrapper } from 'src/components/enterprise/features/Corporate/components/Form/MerchantRestrictionsWrapper/MerchantRestrictionsWrapper';
import { ItemRestrictionsWrapper } from 'src/components/enterprise/features/Corporate/components/Form/ItemRestrictionsWrapper/ItemRestrictionsWrapper';
import { DinerNotificationPreferencesWrapper } from 'src/components/enterprise/features/Corporate/components/Form/DinerNotificationPreferences/DinerNotificationPreferencesWrapper';
import PageSection from 'src/components/enterprise/layout/PageSection';

export const FeaturesSection: React.FC = () => {
  return (
    <Stack y="md">
      <PageSection>
        <Stack y="md">
          <PageSectionTitle
            title="Features"
            subtitle="Choose features to enable for this client"
          />
        </Stack>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <Allocations name="allocationsPermitted" id="allocations" />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <AutomatedWelcomeEmails
                name="automatedEmailsEnabled"
                id="automatedEmailsEnabled"
              />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <ScheduledTeamOrders
                name="groupOrderEnabled"
                id="groupOrderEnabled"
              />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <GrubhubSeamlessPlusWrapper />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <OrderingPolicyWrapper />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <PIISensitiveControl
                name="piiProtectedMarketing"
                id="piiProtectedMarketing"
              />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <SFTPWrapper />
            </Stack>
          </Column>
        </Row>
        <Stack y="sm">
          <SSOWrapper />
        </Stack>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <TaxExemptionControl
                name="taxExemptEnabled"
                id="taxExemptEnabled"
              />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <UniversalLoginControl
                name="universalAccountsEnabled"
                id="universalAccountsEnabled"
              />
            </Stack>
          </Column>
        </Row>
        <Row gutter={12}>
          <Column phone={6} gutter={12}>
            <Stack y="sm">
              <OrderCutoffControl
                name="disableMealCreditGracePeriod"
                id="disableMealCreditGracePeriod"
              />
            </Stack>
          </Column>
        </Row>
        <OrderRestrictionsProvider>
          <Stack y="sm">
            <MerchantRestrictionsWrapper />
          </Stack>
          <Stack y="sm">
            <ItemRestrictionsWrapper />
          </Stack>
        </OrderRestrictionsProvider>
        <DinerNotificationPreferencesWrapper />
      </PageSection>
    </Stack>
  );
};
